var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1032 55.1129C20.1032 56.3908 19.067 57.4272 17.7889 57.4272C16.5108 57.4272 15.4746 56.3908 15.4746 55.1129V43.5415C15.4746 32.0382 24.7999 22.7129 36.3032 22.7129C47.8065 22.7129 57.1317 32.0382 57.1317 43.5415V55.1129C57.1317 56.3908 56.0954 57.4272 54.8175 57.4272C53.5395 57.4272 52.5032 56.3908 52.5032 55.1129H20.1032Z",
    fill: "#FFCACF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7742 7.67162C39.7742 5.7544 38.22 4.2002 36.3028 4.2002C34.3856 4.2002 32.8314 5.7544 32.8314 7.67162V14.6145C32.8314 16.5317 34.3856 18.0859 36.3028 18.0859C38.22 18.0859 39.7742 16.5317 39.7742 14.6145V7.67162ZM40.9314 42.3859C40.9314 39.8296 38.8591 37.7573 36.3028 37.7573C33.7465 37.7573 31.6742 39.8296 31.6742 42.3859V53.9573C31.6742 54.3568 31.7249 54.7447 31.82 55.1145H15.4742C11.6398 55.1145 8.53139 58.223 8.53139 62.0573C8.53139 65.8916 11.6398 69.0002 15.4742 69.0002H57.1314C60.9657 69.0002 64.0742 65.8916 64.0742 62.0573C64.0742 58.223 60.9657 55.1145 57.1314 55.1145H40.7856C40.8807 54.7447 40.9314 54.3568 40.9314 53.9573V42.3859ZM63.3966 11.8208C64.7523 13.1765 64.7523 15.3744 63.3966 16.7302L58.4871 21.6395C57.1314 22.9952 54.9333 22.9952 53.5776 21.6395C52.2219 20.2838 52.2219 18.0858 53.5776 16.7302L58.4871 11.8208C59.8428 10.4651 62.0409 10.4651 63.3966 11.8208ZM9.20915 16.7302C7.85346 15.3744 7.85346 13.1765 9.20915 11.8208C10.5648 10.4651 12.7628 10.4651 14.1185 11.8208L19.0278 16.7302C20.3835 18.0858 20.3835 20.2838 19.0278 21.6395C17.6721 22.9952 15.4741 22.9952 14.1185 21.6395L9.20915 16.7302Z",
    fill: "#F84343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsp3);
export default __webpack_public_path__ + "static/media/ssp_3.97d078da654a18bca41c3f8a1bda29a7.svg";
export { ForwardRef as ReactComponent };